import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'slugify'
})
export class SlugifyPipe implements PipeTransform {

  transform(str: string): string {
    return typeof str === 'string'
        ? str.toLowerCase().replace(/\s+/g, '-')
        : str;
}

}
